import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface State {
  workspaceId: string | null;
}

interface Actions {
  setWorkspaceId: (workspaceId: string | null) => void;
  resetWorkspaceId: () => void;
}

const initialState: State = {
  workspaceId: null,
};

export const useWorkspaceIdStore = create<State & Actions>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        setWorkspaceId(workspaceId) {
          set({ workspaceId });
        },
        resetWorkspaceId() {
          set({ workspaceId: null });
        },
      }),
      { name: 'workspace-id-storage' },
    ),
    { name: 'workspace-id-store' },
  ),
);
